<template>
  <tr
    :class="{ highlighted }"
    :key="ranking.playerName"
    :data-qe-id="!!highlighted ? 'tr-data-highlighted' : 'tr-data'"
  >
    <td>{{ ranking.seasonRank }}</td>
    <td>{{ ranking.playerName }}</td>
    <td>{{ ranking.seasonScore }}</td>
    <td>{{ ranking.seasonPrize }}</td>
    <td v-if="isTicketColumnRendered">
      <c-ticket-icon v-if="ranking.ticketInfo" />
    </td>
  </tr>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { SeasonRanking } from '@/model/ranking/Season'
import { TableFilter } from '@/model/ranking/TableFilter'
import CTicketIcon from '@/components/CTicketIcon.vue'

const props = withDefaults(
  defineProps<{
    ranking: SeasonRanking
    highlighted: boolean
    type: string
  }>(),
  {
    highlighted: false,
    type: TableFilter.DEFAULT,
  }
)

const isTicketColumnRendered = computed(() => {
  return props.type === TableFilter.DEFAULT
})
</script>

<style lang="less" scoped></style>
